// extracted by mini-css-extract-plugin
export var btgLogo = "AboutOverlay-module--btgLogo--mjlj7";
export var close = "AboutOverlay-module--close--fky2q";
export var isOpen = "AboutOverlay-module--isOpen--CQCWx";
export var refraccionesLogo = "AboutOverlay-module--refraccionesLogo--XIFkv";
export var root = "AboutOverlay-module--root--Gog2o";
export var text = "AboutOverlay-module--text--cDW8T";